/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AuthContext } from '../context';
import { ProductsService } from '../services';

// Layout
import Layout from './layout';

// Auth
import Login from '../screens/auth/login';
import Logout from '../screens/auth/logout';
import Register from '../screens/auth/register';
import Recover from '../screens/auth/recover';
import Referrals from '../screens/public/referrals/referrals';

// Client Screens
import Onboarding from '../screens/client/onboarding/onboarding';
import Home from '../screens/client/home/home';
import Profile from '../screens/client/profile/profile';
import ProductDetails from '../screens/client/home/product-details';
import PurchaseBeneficiaries from '../screens/client/purchase/beneficiaries';
import PurchaseCurrent from '../screens/client/purchase/current';
import Payment from '../screens/client/payment/payment';
import PaymentCash from '../screens/client/payment/cash';
import PaymentMobile from '../screens/client/payment/mobile';
import PaymentTransferManual from '../screens/client/payment/transfer-manual';
import PaymentTransfer from '../screens/client/payment/transfer';
import PaymentTransferBNC from '../screens/client/payment/transfer-bnc';
import PaymentZelle from '../screens/client/payment/zelle';
import Payments from '../screens/client/payment/payments';
import CompleteVehicleData from '../screens/client/payment/complete-vehicle-data';
import ProductHistory from '../screens/client/product-history/product-history';
import Requests from '../screens/client/requests/requests';
import RequestsHistory from '../screens/client/requests/history';
import RequestService from '../screens/client/requests/request-service';

const Router = () => {
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);
  const { isLogged, user } = useContext(AuthContext);

  const updateCart = async () => {
    const productsIds = cart.map(x => x.id).join(',');
    const res = await ProductsService.getProductsFromCart({ ids: productsIds });

    const nonUpdatedProducts = [];
    res.data?.forEach(p => {
      // Si el producto no se ha actualizado, se agrega al carrito
      const product = cart.find(cp => cp.id === p.id && cp.updated_at === p.updated_at);
      if (!product) return;

      nonUpdatedProducts.push({
        ...p,
        selectedPriceId: product.selectedPriceId,
        selectedDeductible: product.selectedDeductible,
      });
    });

    dispatch({ type: 'SET_CART', payload: nonUpdatedProducts });
  }

  useEffect(() => {
    // Al recargar la página, se borra el request para que inicie el proceso de compra y ejecute el flujo secuencial para evitar posibles errores
    dispatch({ type: 'SET_REQUEST', payload: null });

    // Actualizar los productos en el carrito
    if (isLogged && !!user && cart?.length) updateCart();
  }, []);

  return isLogged ? <AdminRoutes /> : <AuthRoutes />;
}

const AuthRoutes = () => (
  <HashRouter>
    <Switch>
      <Route exact path="/" component={Login} />
      <Route exact path="/referidos/:code" component={Referrals} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/register/google/:content" component={Register} />
      <Route exact path="/recover" component={Recover} />
      <Route exact path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  </HashRouter>
)

const AdminRoutes = () => (
  <HashRouter>
    <Switch>
      <Route>
        <Layout>
          <Switch>
            {/* Para que puedan abrir un link de referido con una cuenta ya abierta */}
            <Route exact path="/referidos/:code" component={Referrals} />

            <Route exact path="/" component={Home} />
            <Route exact path="/bienvenida" component={Onboarding} />
            <Route exact path="/perfil" component={Profile} />
            <Route exact path="/productos/:idBase64" component={ProductDetails} />
            <Route exact path="/mi-pedido/beneficiarios" component={PurchaseBeneficiaries} />
            <Route exact path="/mi-pedido" component={PurchaseCurrent} />
            <Route exact path="/pagar" component={Payment} />
            <Route exact path="/pagar/deposito" component={PaymentCash} />
            <Route exact path="/pagar/pago-movil/banco" component={PaymentMobile} />
            <Route exact path="/pagar/transferencia" component={PaymentTransferManual} />
            <Route exact path="/pagar/pago-movil/directo" component={PaymentTransfer} />
            <Route exact path="/pagar/debito-inmediato" component={PaymentTransferBNC} />
            <Route exact path="/pagar/zelle" component={PaymentZelle} />
            <Route exact path="/historial/pagos" component={Payments} />
            <Route exact path="/historial/pagos/completar" component={CompleteVehicleData} />
            <Route exact path="/historial/productos" component={ProductHistory} />
            <Route exact path="/historial/servicios" component={RequestsHistory} />
            <Route exact path="/solicitudes" component={Requests} />
            <Route exact path="/servicios/solicitar" component={RequestService} />

            <Route exact path="/logout" component={Logout} />
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </Layout>
      </Route>

      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  </HashRouter>
)

export default Router;